import React from "react";

class ErrorBoundary extends React.Component {
    state = { hasError: false};

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.log("Component render failed!");
        console.log(this.props.children);
    }

    render() {
        if (this.state.hasError) {
            const icon = <i className="pi pi-times" style={{color: "indianred", fontSize: "3rem"}}/>
            const errorMsg = "This component crashed!";
            return <h1 style={{display: "flex", alignItems: "center", justifyContent: "center"}}>{icon}{errorMsg}{icon}</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary